import { jsxs as t, jsx as l } from "react/jsx-runtime";
import { E as p, S as s } from "./icons.types-0722eef5.js";
function R({ title: c, titleId: n, size: e, width: o, height: a, extended: d = !1, ...v }) {
  const i = d ? p : s, f = e ? i[e] : o || i[d ? "s" : "l"], h = e ? i[e] : a || i[d ? "s" : "l"];
  return /* @__PURE__ */ t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: f,
      height: h,
      "aria-labelledby": n,
      ...v,
      children: [
        c ? /* @__PURE__ */ l("title", { id: n, children: c }) : null,
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#1B75BB",
            d: "M4 29h64v14H4V29Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#E6E7E8",
            d: "M58 14H14C7.373 14 4 18.925 4 25v4h64v-4c0-6.075-3.373-11-10-11Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            d: "M4 47c0 6.075 3.373 11 10 11h44c6.627 0 10-4.925 10-11v-4H4v4Z"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#EC1C24",
            fillRule: "evenodd",
            d: "M27.336 21.201c.443.145.456.145.428.59-.088 1.375-.187 2.751-.28 4.127-.053.791-.106 1.583-.157 2.375-.069.984-.131 1.968-.459 2.91-.931 2.674-2.729 4.479-5.407 5.412a.5.5 0 0 1-.336 0 8.43 8.43 0 0 1-5.811-7.622c-.01-.232-.036-.467-.054-.7-.092-1.325-.183-2.65-.272-3.976-.062-.926-.117-1.851-.181-2.777-.008-.107.016-.175.119-.215.11-.04.217-.082.324-.125.109.038.111.131.125.225.062.405.071.815.094 1.22.063 1.133.156 2.267.223 3.397.053.976.127 1.95.196 2.924.146 1.986.867 3.722 2.282 5.157.803.811 1.749 1.388 2.795 1.819a.8.8 0 0 0 .654 0c1.799-.717 3.187-1.898 4.121-3.604.518-.94.83-1.98.918-3.049.084-.972.132-1.948.205-2.922.081-1.089.143-2.181.232-3.27.044-.541.06-1.083.111-1.625.011-.104-.003-.222.13-.271Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#005DA3",
            fillRule: "evenodd",
            d: "M27.336 21.201c-.091 1.302-.175 2.602-.27 3.904-.118 1.564-.105 3.149-.364 4.697-.515 3.097-2.302 5.19-5.229 6.314a.48.48 0 0 1-.361 0c-2.921-1.117-4.691-3.208-5.23-6.288-.229-1.308-.211-2.65-.311-3.974-.113-1.551-.214-3.102-.321-4.654a13.997 13.997 0 0 1 4.104-1.139 15.099 15.099 0 0 1 6.561.596c.483.154.962.323 1.421.544Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#FEFEFE",
            fillRule: "evenodd",
            d: "M23.729 26.981c.799 1.065 1.582 2.109 2.363 3.153.034.044.069.087.062.155-.179 1.457-1.443 1.847-2.34 1.383-.61-.314-1.187-.322-1.791-.002a1.49 1.49 0 0 1-1.467-.004c-.597-.316-1.169-.314-1.77 0-.624.328-1.336.211-1.843-.241-.346-.308-.394-.741-.511-1.145-.016-.058.021-.097.052-.137l2.373-3.163c.322.429.633.843.973 1.292.489-.97.962-1.918 1.461-2.912.499.99.974 1.936 1.463 2.912.334-.44.644-.851.975-1.291Zm.989 6.269a7.504 7.504 0 0 1-1.893 1.702c-.419.259-.86.478-1.319.656a.522.522 0 0 1-.41.008c-1.268-.489-2.331-1.256-3.232-2.362.541.067.937-.23 1.382-.366.39-.117.785-.087 1.144.113.61.336 1.198.328 1.813 0 .472-.252.969-.237 1.447.002.317.163.641.282 1.068.247Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#FEFEFE",
            fillRule: "evenodd",
            d: "M17.06 32.02c.263.131.47.238.7.274.403.065.777-.016 1.137-.207.509-.271 1.027-.274 1.535-.002.578.304 1.145.302 1.723-.004.51-.269 1.028-.262 1.535.006.587.314 1.167.31 1.741-.028a.79.79 0 0 1-.606.702 1.47 1.47 0 0 1-1.018-.153c-.593-.324-1.169-.33-1.766-.008a1.542 1.542 0 0 1-1.515-.006c-.576-.31-1.143-.316-1.718 0-.15.09-.318.148-.492.167-.76.066-.873.002-1.142-.535-.023-.053-.055-.103-.114-.206Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#C0BD28",
            fillRule: "evenodd",
            d: "M21.583 23.976c.038-.02.076-.04.113-.062.038.018.092.063.065.087-.055.048-.122.019-.178-.025Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#FED100",
            fillRule: "evenodd",
            d: "m19.297 21.01.153-.348.155.348.382-.04-.226.31.226.308-.382-.04-.155.352-.153-.352-.384.04.227-.308-.227-.31.384.04Zm1.833 2.451.159-.351.155.351.382-.044-.229.31.229.313-.382-.044-.155.352-.159-.352-.38.044.227-.313-.227-.31.38.044Zm1.865-2.451.155-.348.155.348.382-.04-.227.31.227.308-.382-.04-.155.352-.155-.352-.382.04.227-.308-.227-.31.382.04Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
export {
  R as SvnSlovenia
};
